import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-calendar-consent-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  templateUrl: './calendar-consent-dialog.component.html',
  styleUrl: './calendar-consent-dialog.component.scss',
})
export class CalendarConsentDialogComponent {
  /** Controls dialog visibility – driven by the parent. */
  @Input() visible = false;

  /** Emits true (accepted) or false (declined) when the user makes a choice. */
  @Output() consentDecision = new EventEmitter<boolean>();

  accept(): void {
    this.consentDecision.emit(true);
  }

  decline(): void {
    this.consentDecision.emit(false);
  }
}
